import firebase from "datastore/database";
import store from "datastore/store";

const getCollectionUrl = (uid) => `shifts/business/${uid}`;

export async function update(businessUid, uid, data) {
  return firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc(uid)
    .update(data);
}

export function add(businessUid, data) {
  const doc = firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc();
  doc.set(data);
  return { uid: doc.id, ...data };
}

export async function deleteShift(businessUid, uid) {
  return firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc(uid)
    .delete();
}

export function observe(businessUid) {
  const path = getCollectionUrl(businessUid);
  store.dispatch({ type: "SET_SHIFTS_LOADING", data: true });
  return firebase
    .firestore()
    .collection(path)
    .onSnapshot((snapshot) => {
      const shifts = snapshot.docs.map((doc) => ({
        ...doc.data(),
        uid: doc.id,
      }));
      store.dispatch({ type: "SET_SHIFTS", data: shifts });
      store.dispatch({ type: "SET_SHIFTS_LOADING", data: false });
    });
}
